export default "<h1 style=\"margin-top:90px; padding:20px\">\n  404 wow not so much of those html text things here.\n</h1>\n"